export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  discountPrice?: number;
  images: string[];
  category: string;
  tags?: string[];
  inStock: boolean;
  featured?: boolean;
  rating?: number;
  reviews?: Review[];
}

export interface Review {
  id: string;
  userId: string;
  userName: string;
  rating: number;
  comment: string;
  date: string;
}

export interface Category {
  id: string;
  name: string;
  description?: string;
  image?: string;
}

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  address?: Address;
  orders?: Order[];
}

export interface Address {
  street: string;
  city: string;
  state?: string;
  postalCode: string;
  country: string;
}

export interface Order {
  id: string;
  userId: string;
  items: OrderItem[];
  totalAmount: number;
  shippingAddress: Address;
  paymentMethod: string;
  status: OrderStatus;
  createdAt: string;
  updatedAt: string;
}

export interface OrderItem {
  productId: string;
  name: string;
  price: number;
  quantity: number;
}

export enum OrderStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SHIPPED = 'SHIPPED',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED',
}

// Bahrain cities for checkout form
export const BAHRAIN_CITIES = [
  'Manama',
  'Riffa',
  'Muharraq',
  'Hamad Town',
  'A\'ali',
  'Isa Town',
  'Sitra',
  'Budaiya',
  'Jidhafs',
  'Al Hidd',
  'Sanabis',
  'Tubli',
  'Sanad',
  'Adliya',
  'Busaiteen',
  'Amwaj Islands',
  'Durrat Al Bahrain',
  'Zallaq',
  'Al Jasra',
  'Awali',
  'Other'
];

export const PRODUCT_CATEGORIES = [
  { id: 'perfumes', name: 'Perfumes' },
  { id: 'oud', name: 'Oud & Fragrance Oils' },
  { id: 'gift-sets', name: 'Gift Sets' },
  { id: 'accessories', name: 'Accessories' },
  { id: 'home-fragrance', name: 'Home Fragrance' },
  { id: 'skincare', name: 'Skincare' },
];

export const PAYMENT_METHODS = [
  { id: 'card', name: 'Credit/Debit Card' },
  { id: 'paypal', name: 'PayPal' },
  { id: 'cash', name: 'Cash on Delivery' },
  { id: 'bank-transfer', name: 'Bank Transfer' },
]; 